import React from 'react';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import {Fieldset} from "primereact/fieldset";
import {Button, Col, Label, Row} from "reactstrap";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import Translate from "../../shared/language/Translate";
import MerchantBranchCredentialsService from "../../shared/service/MerchantBranchCredentialsService";
import OrderService from "../../shared/service/OrderService";
import {Chart} from "primereact/chart";
import DateInput from "../../shared/component/form/DateInput";
import ZXReportService from "../../shared/service/ZXReportService";
import AvField from "../../shared/component/form/AvField";
import {DAYS_FILTER} from "../../shared/utils/Constants";

const defaultSummary = {
    netSale: 0,
    grossSale: 0,
    refunds: 0,
    netSaleCnt: 0,
    grossSaleCnt: 0,
    refundsCnt: 0,
    totalSale: 0,
    tillTotalSale: 0,
    tillCash: 0,
    tillCard: 0,
    webPay: 0,
};

export default class ReportSummary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orderNo: null,
            daysFilter: "Last 7 Days",
            startDate: GeneralUtils.getLast7DaysRange()[0].getTime(),
            endDate: GeneralUtils.getLast7DaysRange()[1].getTime(),
            clientList: [],
            summary: Object.assign(defaultSummary),
        };
        this.merchantBranchCredentialsService = new MerchantBranchCredentialsService();
        this.orderService = new OrderService();
        this.zxReportService = new ZXReportService();
    }

    componentDidMount() {
        this.merchantBranchCredentialsService.getClientTills(localStorage.getItem('merchantBranchId')).then(response => this.setState({
            clientList: response
        }));

        this.refreshSummary();
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false, orderNo: null});
    }

    render() {
        return (<div>
            <AvForm>
                {this.renderFilter()}
                {this.renderSummaryGraphics()}
            </AvForm>
        </div>);

    }

    renderFilter() {
        return (<div>


            <Row>

                <Col md="2" className="mb-3">

                    <AvGroup>

                        <AvField
                            type="select"
                            className="form-control"
                            name="clientAgent"
                            value={this.state.clientAgent}
                            onChange={this.__handleChangeClientAgent}>
                            <option value="" key="">
                                ALL
                            </option>
                            {this.state.clientList.map(element => (
                                <option value={element.bssId} key={element.clientTillId}>
                                    {element.clientTillId}
                                </option>))}
                        </AvField>

                    </AvGroup>
                </Col>

                <Col md="2" className="mb-3">

                    <AvGroup>

                        <AvField
                            type="select"
                            className="form-control"
                            name="daysFilter"
                            value={this.state.daysFilter}
                            onChange={this.__handleChangeDaysFilter}>
                            {DAYS_FILTER.map(element => (
                                <option value={element.value} key={element.value}>
                                    {element.name}
                                </option>))}
                        </AvField>

                    </AvGroup>

                </Col>

                <Col md="2" className="mb-3">

                    <DateInput
                        name="startDate"
                        format={"DD/MM/YYYY"}
                        placeholder={"Start Date"}
                        onChange={this.__handleChangeStartDate}
                        disabled={this.state.daysFilter !== 'Custom'}
                        value={this.state.startDate}/>


                </Col>

                <Col md="2" className="mb-3">

                    <DateInput
                        name="endDate"
                        format={"DD/MM/YYYY"}
                        placeholder={"End Date"}
                        onChange={this.__handleChangeEndDate}
                        disabled={this.state.daysFilter !== 'Custom'}
                        value={this.state.endDate}/>


                </Col>


            </Row>
            <Row>
                <Col className="mb-3">
                    <Button color="outline-primary" style={{marginBottom: "10px", marginTop: "10px"}}
                            onClick={() => {
                                this.search();
                            }}>
                        <Translate contentKey="entity.action.add">Search</Translate>
                    </Button>
                </Col>

            </Row>
        </div>)
    }


    search() {
        this.refreshSummary();
    }

    __handleChangeStartDate = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({startDate: value}, () => {
            this.search(); // This will run after state is updated
        });
    }

    __handleChangeEndDate = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({endDate: value}, () => {
            this.search(); // This will run after state is updated
        });
    }

    __handleChangeClientAgent = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({clientAgent: value}, () => {
            this.search(); // This will run after state is updated
        });
    }

    __handleChangeDaysFilter = (e) => {
        const selectedFilter = e.target.value;
        let startDate = null;
        let endDate = null;

        switch (selectedFilter) {
            case 'Today':
                startDate = GeneralUtils.getStartOfToday();
                endDate = GeneralUtils.getEndOfToday();
                break;
            case 'This Week':
                startDate = GeneralUtils.getMonday();
                endDate = GeneralUtils.getEndOfToday();
                break;
            case 'Last Week':
                [startDate, endDate] = GeneralUtils.getLastWeekRange();
                break;
            case 'Last 7 Days':
                [startDate, endDate] = GeneralUtils.getLast7DaysRange();
                break;
            case 'This Month':
                [startDate, endDate] = GeneralUtils.getThisMonthRange();
                break;
            case 'Last Month':
                [startDate, endDate] = GeneralUtils.getLastMonthRange();
                break;
            case 'Custom':
                [startDate, endDate] = GeneralUtils.getLast7DaysRange();
                break;
            default:
                startDate = this.state.startDate ? new Date(this.state.startDate) : null;
                endDate = this.state.endDate ? new Date(this.state.endDate) : null;
                break;
        }

        this.setState({
            daysFilter: selectedFilter,
            startDate: startDate ? startDate.getTime() : null,
            endDate: endDate ? endDate.getTime() : null
        }, () => {
            this.search(); // This will run after state is updated
        });
    };

    onDataSelect = (data) => {
        this.refModelSave.setData(Object.assign({}, data));
        this.setState({
            displayDialog: true,
            orderNo: data.orderNo
        });

    }

    refreshSummary() {

        let startDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.startDate)) {
            startDate = this.state.startDate;
        }
        let endDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.endDate)) {
            endDate = this.state.endDate;
        }

        let clientAgent = "-1";
        if (!GeneralUtils.isNullOrEmpty(this.state.clientAgent)) {
            clientAgent = this.state.clientAgent;
        }


        this.zxReportService.getSummary(startDate, endDate, clientAgent).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({summary: response});
            }

        });

    }

    renderSummaryGraphics() {
        const tillSaleList = this.state.summary.tillSalesList || [];

        const chartTillsData = {
            labels: tillSaleList.map(item => item.name + ' ' + GeneralUtils.formatGBP(item.amount) + ''),
            datasets: [
                {
                    label: 'Net Sales By Till',
                    backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726'],
                    data: tillSaleList.map(item => parseFloat(item.amount)),
                }
            ]
        };

        const topSalesDepartmentList = this.state.summary.topSalesDepartmentList || [];

        const topSalesDepartmentData = {
            labels: topSalesDepartmentList.map(item => item.name + ' ' + GeneralUtils.formatGBP(item.amount) + ''),
            datasets: [
                {
                    label: 'Top 10 Department Sales',
                    backgroundColor: [
                        '#42A5F5', // Mavi
                        '#66BB6A', // Yeşil
                        '#FFA726', // Turuncu
                        '#AB47BC', // Mor
                        '#26C6DA', // Cam Göbeği
                        '#FF7043', // Mercan
                        '#9CCC65', // Açık Yeşil
                        '#EF5350', // Kırmızı
                        '#7E57C2', // Eflatun
                        '#26A69A'  // Teal
                    ],

                    data: topSalesDepartmentList.map(item => parseFloat(item.amount)),
                }
            ]
        };

        const chartSalesData = {
            labels: ['Net ' + GeneralUtils.formatGBP(this.state.summary.netSale), 'Gross ' + GeneralUtils.formatGBP(this.state.summary.grossSale), 'Refund ' + GeneralUtils.formatGBP(this.state.summary.refunds)],
            datasets: [
                {
                    label: 'Sale Summary Amount (£)',
                    backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726'],
                    data: [this.state.summary.netSale, this.state.summary.grossSale, this.state.summary.refunds],
                }
            ]
        };
        const chartSalesCountData = {
            labels: ['Net ' + this.state.summary.netSaleCnt, 'Gross ' + this.state.summary.grossSaleCnt, 'Refund ' + this.state.summary.refundsCnt],
            datasets: [
                {
                    label: 'Sale Summary Count',
                    backgroundColor: ['#1E88E5', '#43A047', '#FB8C00'],
                    data: [this.state.summary.netSaleCnt, this.state.summary.grossSaleCnt, this.state.summary.refundsCnt]
                }
            ]
        };

        const chartPaymentData = {
            labels: ['WebPay ' + GeneralUtils.formatGBP(this.state.summary.webPay), 'Till Card ' + GeneralUtils.formatGBP(this.state.summary.tillCard), 'Till Cash ' + GeneralUtils.formatGBP(this.state.summary.tillCash)],
            datasets: [
                {
                    label: 'Sale Summary By Payment (£)',
                    backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726'],
                    data: [this.state.summary.webPay, this.state.summary.tillCard, this.state.summary.tillCash]
                }
            ]
        };

        const chartOptions = {
            maintainAspectRatio: false,
            aspectRatio: 1,
            plugins: {
                legend: {
                    labels: {
                        color: '#495057'
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef'
                    }
                },
                y: {
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef'
                    }
                }
            }
        };

        return (
            <div>
                <Fieldset legend={"Summary"}>
                    {/* İlk Satır */}
                    <Row >
                        <Col md={4} className="d-flex justify-content-left">
                            <div className="chart-container text-center">
                                <Chart type="bar" data={chartTillsData} options={chartOptions}/>
                            </div>
                        </Col>


                        <Col md={4} className="d-flex justify-content-left">
                            <div className="chart-container">
                                <Chart type="bar" data={chartPaymentData} options={chartOptions}/>
                            </div>
                        </Col>
                        <Col md={4} className="d-flex justify-content-left">
                            <div className="chart-container">
                                <Chart type="bar" data={chartSalesData} options={chartOptions}/>
                            </div>
                        </Col>
                        <Col md={4} className="d-flex justify-content-left">
                            <div className="chart-container">
                                <Chart type="bar" data={chartSalesCountData} options={chartOptions}/>
                            </div>
                        </Col>


                        <Col md={4} className="d-flex justify-content-left">
                            <div className="chart-container">
                                <Chart type="bar" data={topSalesDepartmentData} options={chartOptions}/>
                            </div>
                        </Col>
                    </Row>

                    {/* İkinci Satır */}
                    <Row className="justify-content-center">

                    </Row>
                </Fieldset>
            </div>
        );


    }


    refreshSummary() {

        let startDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.startDate)) {
            startDate = this.state.startDate;
        }
        let endDate = -1;
        if (!GeneralUtils.isNullOrEmpty(this.state.endDate)) {
            endDate = this.state.endDate;
        }

        let clientAgent = "-1";
        if (!GeneralUtils.isNullOrEmpty(this.state.clientAgent)) {
            clientAgent = this.state.clientAgent;
        }

        this.zxReportService.getSummary(startDate, endDate, clientAgent).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({summary: response});
            }

        });

    }


}

